<script setup lang="ts">
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';

import type { ITreeNodeParentEmits, ITreeNodeParentProps } from './types';

defineProps<ITreeNodeParentProps>();
const emit = defineEmits<ITreeNodeParentEmits>();
</script>

<template>
  <div v-data-qa-auto-id="'VTreeNodeParent'" class="flex items-center">
    <span class="w-full pr-5 word-break sm:w-auto sm:min-w-[320px]">{{ node.label }}</span>
    <span
      v-if="show"
      class="flex gap-2"
    >
      <VIconButton
        :disabled="isLoading"
        :loading="isSaving"
        severity="success"
        icon="pi-check"
        @click="emit('save', node)"
      />
      <VIconButton
        :disabled="isLoading || isSaving"
        severity="danger"
        icon="pi-times"
        @click="emit('reset', node)"
      />
    </span>
  </div>
</template>
